// @ts-ignore
export default () => useGlobalMessage('countries.delivery')?.split(',') ?? []
